import { ValidatorFn } from "@reactables/react-forms";

const length10: ValidatorFn = (value: string) => ({
  length10: value.length !== 10,
});

export { length10 };
